var _path, _path2, _polyline, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPackage = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11 21.73a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 22V12"
})), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
  points: "3.29 7 12 12 20.71 7"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "m7.5 4.27 9 5.15"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgPackage);
export default ForwardRef;